export const environment = {
  NAME: 'development',
  production: false,
  isCn: false,
  mapboxToken:
    'pk.eyJ1IjoiYnJ5YW5oYyIsImEiOiJjbG5lN2hhd3IwZHA0MnNtamFvenpqMjR5In0.v6IJPRIgSL1cjD2WMI75VA',
  TRACEABILITY_API:
    'https://traceability-development.agridence.com/api/v2/traceability/service/',
  TRACEABILITY_API_v1:
    'https://traceability-development.agridence.com/api/v1/traceability/service/',
  TRACEABILITY_API_v3:
    'https://traceability-development.agridence.com/api/v3/traceability/service/',
  TRACEABILITY_INTEGRATIONS_API:
    'https://traceability-development.agridence.com/api/v1/traceability-integrations/',
  TRACEABILITY_EXTERNAL:
    'https://traceability-development.agridence.com/_external/v2/traceability/external/si/',
  ARP_API: 'https://api-platform-testing.agridence.com/api/v1/',
  CRD_API: 'https://api-traceability-crd-development.agridence.com/api/',
  TRACEABILITY_API_CN:
    'https://traceability-development.agridencecn.com/api/v2/traceability/service/',
  TRACEABILITY_API_v1_CN:
    'https://traceability-development.agridencecn.com/api/v1/traceability/service/',
  TRACEABILITY_INTEGRATIONS_API_CN:
    'https://traceability-development.agridencecn.com/api/v1/traceability-integrations/',
  TRACEABILITY_EXTERNAL_CN:
    'https://traceability-development.agridencecn.com/_external/v2/traceability/external/si/',
  ARP_API_CN: 'https://api-platform-testing.agridencecn.com/api/v1/',
  CRD_API_CN: 'https://api-traceability-crd-development.agridencecn.com/api/',
  STORAGE_BUCKET: 'traceability/eudr-packages/{siNumber}/',
  STORAGE_BUCKET_V2: 'traceability/eudr-packages-v2/{siNumber}',
  posthogKey: 'phc_NMIi98nvCxMFry1oys6hGDagws4j623XorKRHjAHSXp',
  posthogHost: 'https://us.i.posthog.com',
  SENTRY: {
    DSN: 'https://8cf2950243e593c8da53c68cdfd489da@o4510859648892928.ingest.de.sentry.io/4510938937163856',
    DEBUG: false
  }
};
